import { getWindowLocationValues } from './helpers'

/**
 * Track when a user reaches the contact information form step.
 *
 * @param {object} statsigClient
 * @param {object} event
 * @param {object} event.scope
 */
export function trackReachedContactFormEvent(statsigClient, { scope }) {
  statsigClient?.logEvent('reached_contact_form', null, {
    ...getWindowLocationValues(scope),
  })
}
